/* 博客列表渐进增强：原生搜索不依赖脚本，仅在已验证的列表结构中处理评论标识。 */
(() => {
  if (customElements.get('ggjia-blog-tools')) return;
  class GGJIABlogTools extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      // 保存服务端生成的 ALL 链接，复用语言前缀和原生搜索路由，不重建已有分类。
      this.allLink = this.querySelector('[data-ga-all-articles]') || this.allLink;
      this.refresh = () => {
        const root = document.querySelector('#MainContent') || document.querySelector('main');
        if (!root) return;
        const categories = root.querySelector('.blog-list-container');
        const firstRow = categories?.querySelector('.blog-list-row');
        if (firstRow && this.allLink) {
          const existing = categories.querySelector('[data-ga-all-articles]');
          if (!existing) {
            this.allLink.classList.add('blog-item');
            firstRow.prepend(this.allLink);
          } else if (existing !== this.allLink && this.contains(this.allLink)) {
            // 重复调用或主题编辑器刷新时，仅移除本模块多余的入口，不改原分类。
            this.allLink.remove();
          }
          categories.setAttribute('data-ga-has-all', '');
        }
        root.querySelectorAll('.main-blog-block').forEach(section => {
          section.classList.add('ggjia-blog-list');
          section.querySelectorAll('.blog-info .blog-comment').forEach(comment => {
            // 当前英语站点输出 0 comments / 1 comment；未知语言或文本不猜测、不删除。
            const label = comment.textContent.trim();
            const match = label.match(/^([\d,]+)\s+comments?$/i);
            if (!match) return;
            const count = Number(match[1].replaceAll(',', ''));
            comment.hidden = count === 0;
            comment.toggleAttribute('data-ga-comment-positive', count > 0);
          });
        });
      };
      this.start = () => {
        this.refresh();
        const root = document.querySelector('#MainContent') || document.querySelector('main');
        if (!root || this.observer) return;
        // 仅观察正文结构与文字变化，兼容列表异步加载；不监听自己修改的属性。
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(root, { childList: true, subtree: true, characterData: true });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true, signal });
      else this.start();
      document.addEventListener('shopify:section:load', this.refresh, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.observer = null;
    }
  }
  customElements.define('ggjia-blog-tools', GGJIABlogTools);
})();
